export default __webpack_public_path__ + "static/media/bg1.527ceab2.jpg";